import { useId, type ChangeEvent } from "react";
import { Search, X } from "lucide-react";

/**
 * Campo de busca das barras de ferramentas.
 *
 * `type="search"` sem a lupa nativa: o ícone é decorativo e o nome acessível
 * vem de `label`, que pode ficar invisível quando a barra já tem contexto.
 */
export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
  label: string;
  placeholder?: string;
  /** Falso esconde o botão de limpar mesmo com texto digitado. */
  clearable?: boolean;
  disabled?: boolean;
  className?: string;
  id?: string;
}

export function SearchInput({
  value,
  onChange,
  label,
  placeholder,
  clearable = true,
  disabled = false,
  className,
  id,
}: SearchInputProps) {
  const generated = useId();
  const inputId = id ?? generated;

  return (
    <div className={className ? `cx-search ${className}` : "cx-search"}>
      <Search size={14} aria-hidden="true" />
      <label className="cx-sr-only" htmlFor={inputId}>
        {label}
      </label>
      <input
        id={inputId}
        type="search"
        value={value}
        placeholder={placeholder}
        disabled={disabled}
        onChange={(event: ChangeEvent<HTMLInputElement>) => onChange(event.target.value)}
      />
      {clearable && value !== "" && !disabled && (
        <button
          type="button"
          className="cx-icon-btn"
          data-size="compact"
          data-variant="bare"
          aria-label={`Limpar ${label.toLowerCase()}`}
          title={`Limpar ${label.toLowerCase()}`}
          onClick={() => onChange("")}
        >
          <X size={13} aria-hidden="true" />
        </button>
      )}
    </div>
  );
}
